export function downloadFile(href, filename) {
  const anchor = document.createElement("a")

  anchor.download = filename
  anchor.href = href

  anchor.click()
}
